var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.tabItems.length > 0
        ? _c("c-tab", {
            attrs: {
              type: "horizon",
              inlineLabel: true,
              dense: true,
              height: _vm.tabHeight,
              tabItems: _vm.tabItems,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (tab) {
                    return [
                      _c(tab.component, {
                        tag: "component",
                        attrs: {
                          lawCode: tab.name,
                          lawName: tab.label,
                          regulationItems: tab.items,
                          contentHeight: _vm.tabHeight,
                        },
                        on: { refresh: _vm.refreshData },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1694372412
            ),
            model: {
              value: _vm.currentLawTab,
              callback: function ($$v) {
                _vm.currentLawTab = $$v
              },
              expression: "currentLawTab",
            },
          })
        : _c(
            "div",
            {
              staticClass: "flex flex-center",
              style: { height: _vm.tabHeight },
            },
            [
              _c("q-spinner-dots", {
                attrs: { color: "primary", size: "40px" },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }